import * as React from 'react';
import * as _ from 'lodash';
import InstallationCard from './InstallationCard';
import { cleanProps } from '../../utilities/props';
import { NewInstallationGroup } from './NewInstallationGroup';
export default function () {
    function repeatInstallationGroup1(installationGroup, installationGroupIndex) {
        return React.createElement(InstallationCard, {
            'key': installationGroup.name + '_' + installationGroupIndex,
            'installationGroup': installationGroup,
            'pending': true
        });
    }
    function repeatInstallationGroup2(installationGroup, installationGroupIndex) {
        return React.createElement(InstallationCard, {
            'key': installationGroup.id + '_' + installationGroupIndex,
            'installationGroup': installationGroup
        });
    }
    return React.createElement('div', _.assign({}, cleanProps(this.props)), React.createElement.apply(this, [
        'div',
        { 'className': 'pj-scope-flex-container' },
        React.createElement(NewInstallationGroup, {}),
        this.props.pendingInstallationGroups.length > 0 ? _.map(this.props.pendingInstallationGroups, repeatInstallationGroup1.bind(this)) : null,
        _.map(this.props.installationGroups, repeatInstallationGroup2.bind(this)),
        React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
        React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
        React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
        React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' }),
        React.createElement('div', { 'className': 'pj-scope-lir pj-scope-lir-flex-dummy' })
    ]));
}